export const citizenshipStatus = [
  'US birth',
  'US Foreign',
  'Naturalized',
  'Derived',
  'Not US',
  'National By Birth In US',
  'National By Birth Outside US'
];

export const DOC_FS240 = 'FS240'
export const DOC_DS1350 = 'DS1350'
export const DOC_FS545 = 'FS545'
export const DOC_N560 = 'N560'
export const DOC_Other = 'Other'

// PVQ Radio values
export const relationshipUsForeignDocuments = [
  DOC_FS240,
  DOC_DS1350,
  DOC_FS545,
  DOC_N560,
  DOC_Other,
];

export const DOC_NaturalizedCertificate = 'NaturalizedCertificate'
export const DOC_NaturalizedPermanentAlien = 'NaturalizedPermanentAlien'
export const DOC_NaturalizedMriv = 'NaturalizedMriv'

// PVQ Radio values
export const relationshipNaturalizedDocuments = [
  DOC_NaturalizedCertificate,
  DOC_NaturalizedPermanentAlien,
  DOC_NaturalizedMriv,
  DOC_Other,
];

export const DOC_DerivedCertificate = 'DerivedCertificate'
export const DOC_DerivedPermanentAlien = 'DerivedPermanentAlien'
export const DOC_DerivedMriv = 'DerivedMriv'

// PVQ Radio values
export const relationshipDerivedDocuments = [
  DOC_DerivedCertificate,
  DOC_DerivedPermanentAlien,
  DOC_DerivedMriv,
  DOC_Other,
];

export const RES_ResidencyPermanent = 'ResidencyPermanent'
export const RES_ResidencyAsylee = 'ResidencyAsylee'
export const RES_ResidencyNonimmigrant = 'ResidencyNonimmigrant'
export const RES_ResidencyTPS = 'ResidencyTPS'
export const RES_ResidencyDACA = 'ResidencyDACA'
export const RES_Other = 'Other'

// PVQ Radio values
export const residencyStatus = [
  RES_ResidencyPermanent,
  RES_ResidencyAsylee,
  RES_ResidencyNonimmigrant,
  RES_ResidencyTPS,
  RES_ResidencyDACA,
  RES_Other,
];

export const DOC_NonPermanent = 'NonPermanent'
export const DOC_NonEmployment = 'NonEmployment'
export const DOC_NonMRIV = 'NonMRIV'
export const DOC_NonArrival = 'NonArrival'
export const DOC_NonVisa = 'NonVisa'
export const DOC_NonF1 = 'NonF1'
export const DOC_NonJ1 = 'NonJ1'

// PVQ Radio values
export const relationshipNonCitizenDocuments = [
  DOC_NonPermanent,
  DOC_NonEmployment,
  DOC_NonMRIV,
  DOC_NonArrival,
  DOC_NonVisa,
  DOC_NonF1,
  DOC_NonJ1,
  DOC_Other,
];
